import { useQuery } from "@tanstack/react-query";

import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { QueryErrorState } from "@/components/query-error-state";
import { StatCard } from "@/components/stat-card";
import { apiGet } from "@/lib/api-client";
import { asCurrency, asPercent } from "@/lib/format";

interface RiskSettings {
  max_position_size: number;
  max_total_exposure: number;
  min_edge_threshold: number;
  kelly_fraction: number;
}

export function RiskPanel() {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["risk-settings"],
    queryFn: () => apiGet<RiskSettings>("/api/settings/risk"),
  });

  return (
    <Panel title="Risk Settings">
      {isLoading ? (
        <LoadingState text="Loading risk settings..." />
      ) : isError ? (
        <QueryErrorState what="risk settings" onRetry={() => refetch()} />
      ) : (
        <div className="grid grid-cols-2 gap-3">
          <StatCard label="Max Position" value={asCurrency(data?.max_position_size)} />
          <StatCard label="Max Exposure" value={asCurrency(data?.max_total_exposure)} />
          <StatCard label="Min Edge" value={asPercent(data?.min_edge_threshold)} />
          <StatCard label="Kelly Fraction" value={asPercent(data?.kelly_fraction)} />
        </div>
      )}
    </Panel>
  );
}
